import { useState } from "react";
import { useTranslation } from "react-i18next";

import { InputQuantity } from "../../../../../components";

const PackageQuantitySelect = ({ initialPackageQuantity, onUpdateQuantity = (newQuantity) => { }, isEditable=true }) => {
    const { i18n } = useTranslation();
    const [inputQuantity, setInputQuantity] = useState(initialPackageQuantity)

    const handleOnUpdateQuantity = (newQuantity) => {
        setInputQuantity(newQuantity)
        onUpdateQuantity(newQuantity)
    }

    return (
        <div className="p-4 border-t flex justify-between">
            <span className="font-medium text-lg flex items-center">{i18n.t('generate_shipment.shipping_package_data.package')}s</span>
            {isEditable ? (
                <InputQuantity
                    initialValue={inputQuantity}
                    updateData={handleOnUpdateQuantity}
                />
            ) : (
                <div className="mr-2">{inputQuantity}</div>
            )}
        </div>
    )
}

export default PackageQuantitySelect
